export default __webpack_public_path__ + "static/media/new-pitch-cricket.3d2ed931.png";